<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">Select destination folder</div>

    <div class="modal-body cl-form">
      <p class="mb-2 no-wrap">{{ folder?.id }}</p>

      <div class="files-table-scroll">
        <table class="cl-table-data cl-table-data-light">
          <thead>
            <tr>
              <th class="cl-table-head">Folder</th>
            </tr>
          </thead>
          <tbody>
            @if (loading) {
              <tr class="cl-tr-no-data"><td colspan="100">
                <div class="cl-spinner">Loading ...<i class="fas fa-spinner fa-spin"></i></div>
              </td></tr>
            } @else {
              @if (folder?.parents?.length) {
                <tr>
                  <td>
                    <a role="button" (click)="up()"><i class="fas fa-arrow-up"></i> ..</a>
                  </td>
                </tr>
              }
              @for (sub of folder?.folders; track sub.id) {
                <tr>
                  <td>
                    <a role="button" (click)="open(sub)"><i class="fas fa-folder"></i> {{ sub.name }}</a>
                  </td>
                </tr>
              }
              @if (!folder?.parents?.length && !folder?.folders?.length) {
                <tr class="cl-tr-no-data"><td colspan="100">No subfolders</td></tr>
              }
            }
          </tbody>
        </table>
      </div>

      <label for="new_folder_name" class="form-label mt-3">Create a new folder here</label>
      <div class="d-flex new-folder-row">
        <input id="new_folder_name" type="text" class="form-control" [(ngModel)]="new_folder_name"
          [disabled]="loading || creating" (keyup.enter)="createFolder()"/>
        <button type="button" class="btn cl-color-secondary" [disabled]="loading || creating || !new_folder_name?.trim()"
          (click)="createFolder()">
          <span>Create</span>
        </button>
      </div>

      @if (errorMessage) {
        <p class="alert cl-alert-danger" role="alert">{{ errorMessage }}</p>
      }
    </div>

    <div class="modal-footer">
      <span class="modal-footer-left cl-spacing-box cl-spacing-none">
        <button type="button" class="btn cl-color-secondary it-cancel" (click)="cancel()">
          <span>Cancel</span>
        </button>
      </span>
      <span class="modal-footer-center"></span>
      <span class="modal-footer-right">
        <button type="button" class="btn cl-color-primary" [disabled]="loading || !folder" (click)="selectCurrent()">
          <span>Select this folder</span>
        </button>
      </span>
    </div>
  </div>
</div>
